export default __webpack_public_path__ + "final_model.24f4bb10.fbx";